// Récupération de la valeur de la constante NO_LAZYLOAD pour appliquer le paramètre aux swiper
$(function () {
    setTimeout(function(){
        if($('#FreeShippingBanner').length) {
            $("body").removeClass("promo_on");
            $("body").addClass("global_e_banner");
        }
    }, 800);

    var topAccount = $(".block_top_item.is_logged");
    var topProduct = $("#cart_top, #wishlist_top");
    var topConnexion = $('.connexion_top');
    var menuShade = $('#shad_menu');
    var topaCartDeatil = $('#show_top_cart');
    var topRecherche = $("#trigger_recherche");
    var topSearch = $('.wrap_search_field');
    var searchInput = $('#search_home');

    $(topRecherche).on('click touchstart', function (evt) {

        if (!topSearch.hasClass("appear")) {
            evt.preventDefault();
            topSearch.addClass("appear");
            topSearch.show();
            searchInput.focus();
            menuShade.addClass("actif_search");
        }
        else{
            topSearch.removeClass("appear");
            topSearch.hide();
            menuShade.removeClass("actif_search");
        }
    });

    $('body').on('click','#searchComponent .title_search h1',function() {
        $('#trigger_recherche').click();
        $('#search_home').focus();
    });

    menuShade.on("touchstart", function(){
        topAccount.removeClass("hover");
        topConnexion.removeClass("appear");
        menuShade.removeClass("actif rollPanier");
    });

    $(".block_top_item.is_logged > a").on("touchstart", function(e){
        e.preventDefault();
        topAccount.addClass("hover");
        topConnexion.addClass("appear");
        menuShade.addClass("actif rollPanier");
    });

    $(topAccount).on('mouseenter ', function (evt) {
        $(this).addClass("underlined");

        if (!topConnexion.hasClass("appear")) {
            evt.preventDefault();
            topConnexion.addClass("appear");
            topaCartDeatil.removeClass("appear");
            menuShade.addClass("actif rollPanier");
        }
    });

    $(menuShade).on('click touchstart', function () {
        if (!topSearch.hasClass("actif_search")) {
            topSearch.removeClass("appear");
            topSearch.hide();
            menuShade.removeClass("actif_search");
        }
    });

    topAccount.on('mouseleave', function () {
        $(this).removeClass("underlined");
        closeMonCompte();
    });

    function closeMonCompte(){
        var topConnexion = $('.connexion_top');
        if (topConnexion.hasClass("appear")) {
            topConnexion.removeClass("appear");
            $(this).removeClass("underlined");
            $('#shad_menu').removeClass("actif rollPanier");
        }
    }

    topProduct.on('mouseenter touch', function (evt) {
        $(this).addClass("underlined");

        if(!$(this).children('#show_top_cart').hasClass("hide")){
            evt.preventDefault();
            topProductAppear($(this));
            $(this).unbind('touch');
        }
    });

    topProduct.on('mouseleave', function () {
        $(this).removeClass("underlined");
        topProductDesappear();
    });

    var menu_timeout = setTimeout(null);

    $(".menu_itm_hover").on("touchstart", function (evt) {
        var mainmenu = $("nav.header_main_wrapper");
        var submenu = $(".submenu_wrapper", this);
        $(".submenu_wrapper", !this).hide();
        clearTimeout(menu_timeout);

        if (!mainmenu.hasClass("actif")) {
            $(this).addClass("hovering");
            evt.preventDefault();
            menuShade.addClass("actif");
            mainmenu.addClass("actif");
            menu_timeout = setTimeout(function () {
                submenu.stop(true, true).fadeIn(100, 'easeOutExpo').css({"display":"flex" , "opacity":"1"});
            }, 250);
        } else {
            if (!$(this).hasClass("hovering")) {
                evt.preventDefault();
                $(this).addClass("hovering");
            }

            $(".submenu_wrapper").css("zIndex", 10);
                submenu.show().css({"display":"flex" , "opacity":"1"});
                submenu.css("zIndex", 13);

            if (submenu.is(':visible')) {
                menuShade.addClass("actif");
            }
        }
    });

    $(".return_menu").on("click", function () {
        if($(".menu_itm_hover.hovering").length){
            var activeID = $(".menu_itm_hover.hovering").attr("id");

            $('#' + activeID).removeClass('hovering');
            $('#' + activeID).find('.ss_menu_categ_wrapper').css({"opacity":"0", "z-index":"-1"});
        }
    });

    $("#shad_menu").on("touchstart", function (evt) {
        if ($("#shad_menu.actif").length){
            menuShade.removeClass("actif");
            $("nav.header_main_wrapper").removeClass("actif");
            $(".menu_itm_hover").removeClass("hovering");
            $(".submenu_wrapper").hide();
        }
    });

    $('.menu_categ_wrapper').on("mouseenter", function(){
        //Si on est en résolution supérieure à 1201, on gère l'effet de hover sur les items du menu
        if (window.matchMedia("(max-width: 1023px)").matches) {
            $(".menu_itm_hover .title_categ").on("click", function (evt) {
                evt.preventDefault();
                var submenuBurger = $(".submenu_wrapper");
                $(this).addClass("actifBurger");
            });
            $(".return_menu").on("click", function () {
                $(".menu_itm_hover .title_categ").removeClass("actifBurger");
            });
        } else{
            $(".menu_itm_hover").on("mouseenter", function(){triggerShad("menu", "add")});
            $(".menu_itm_hover").on("mouseleave", function(){triggerShad("menu", "remove")});
        }
    })

    initializeItemSliders();
    // bindProductVisualMultiSwipers();

    if ($(".promo_swiper .swiper-slide").length > 0) {
        promoSwiper = new Swiper(".promo_swiper", {
            centeredSlides: true,
            slidesPerView: 'auto',
            autoplay: { delay: 5000 },
            speed: 1500,
            navigation: {
                nextEl: '.navpromo.promoNext',
                prevEl: '.navpromo.promoPrev',
            },
            on: swiperLazyEvents
        });
    }

    if($('.switchLangWrapper a').length){
        $('.switchLang').on('mouseenter touch', function () {
            $('.switchLangWrapper').fadeIn().css('display', 'flex');
        });

        $('.switchLang').on('mouseleave', function () {
            $('.switchLangWrapper').fadeOut();
        });
    }

    if($('#filter_sticky').length && $('.block_filters .filter_wrapper').length > 5){
        $('.block_filters').addClass('calibrate');
    }

    // Accordéon des filtres (page rayon et page de recherche). Délégué : sur la recherche, les filtres sont rendus par Vue après le chargement.
    $(document).on('click', '.block_filters .filter_wrapper .filter_name', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().find('.wrapper_options.active').removeClass('active');
        }
        else {
            $('.block_filters .filter_name.active').removeClass('active');
            $('.block_filters .wrapper_options.active').removeClass('active');
            $(this).addClass('active');
            $(this).parent().find('.wrapper_options').addClass('active');
            scrollFilterIntoView($(this).closest('.filter_wrapper'));
        }
    });

    $("#searchComponent .title_search h1").on("click", function(){

        var menuShade = $('#shad_menu');
        var topSearch = $('.wrap_search_field');
        var searchInput = $('#search_home');
        topSearch.addClass("appear");
        topSearch.show();
        searchInput.focus();
        menuShade.addClass("actif_search");
    });

    $('.misc_cookiesinfo .content_sat .cookieShowLightbox').click(function() {
        $('.misc_cookiesinfo #cookiesLightbox').addClass('displayCookies');
        if($('.misc_cookiesinfo #cookiesLightbox').has('.hideCookies')) {
            $('.misc_cookiesinfo #cookiesLightbox').removeClass('hideCookies');
        }
        $('.misc_cookiesinfo #cookiesLightbox .w-form-line.w-submit button.w-loader').addClass('hideLoader');
    });

    $('.misc_cookiesinfo #js_cookie_refuse, .misc_cookiesinfo #js_cookie_accept').click(function() {
        if($('.misc_cookiesinfo #cookiesLightbox').has('.displayCookies')) {
            setTimeout(() => {
                $('.misc_cookiesinfo #cookiesLightbox').removeClass('displayCookies');
                $('.misc_cookiesinfo #cookiesLightbox').addClass('hideCookies');
            }, 500);
        }
    });

    $(document).on("click", ".button", btnLoaderTrigger);

    $(document).on("click touch", ".js-close-filter", function () {
        closeFilterPanel();
    });

    $(document).on("keydown", function (evt) {
        if (evt.key === "Escape" && $("#rayon_sticky_block").hasClass("show")) {
            closeFilterPanel();
        }
    });

    initSelectedFilterTags();
    updateApplyCounter();
    $(document).on("change", "#filter_sticky input[type='checkbox'][data-name]", function () {
        updateSelectedFilterTag(this);
    });
    // Seulement les puces de la page rayon (data-target) : celles de la recherche sont rendues et supprimées par Vue
    $(document).on("click touch", ".choices_container .choice_tag[data-target] .close_tag", function () {
        var target = $(this).closest(".choice_tag").data("target");

        // Re-cliquer le tri actif le désactive
        if (target === "tri_price") {
            var $active = $("a.tri_price.actif").first();
            if ($active.length) {
                $active.trigger("click");
            } else {
                $(this).closest(".choice_tag").remove();
                updateApplyCounter();
            }
            return;
        }

        var $input = $("#" + target);
        if ($input.length && $input.is(":checked")) {
            $input.prop("checked", false).trigger("change");
        } else {
            $(this).closest(".choice_tag").remove();
            updateApplyCounter();
        }
    });

    $(document).on("click touch", "a.tri_price", function () {
        // Après le handler inline de object_index.php, qui gère .actif
        var $link = $(this);
        setTimeout(function () { updateSelectedTriTag($link); }, 0);
    });
    initSelectedTriTag();
    // Grille rechargée : le compteur en attente est obsolète
    $(document).on("change", "#totalElems", function () {
        pendingFiltersCount = null;
        updateApplyCounter();
    });

    $(document).on("change", "#filter_sticky input[type='checkbox']", function () {
        refreshFiltersCount();
    });

    $(document).on("click", "#filter_color .form_itm.check.color", function (evt) {
        if ($(evt.target).is("input, label")) return;
        $(this).find("label").trigger("click");
    });

    $(".store_locator").not('#stepStoreList').lionbars();
    $(".lightbox#available-in-store").on('mouseenter touchstart', function (evt) {
        $(".store_locator").not('#stepStoreList').lionbars();
    });

    // Promo bar
    $('.promo_swiper .swiper-slide').each(function () {
        if($(this).css('background-color') == 'rgb(0, 0, 0)'){
            $(this).find('.navpromo').addClass('white');
        }
    });

    infosObligatoires();

    //Toggle code avantage page panier
    $(".coupon .intro_code").on('click', function(){
        $(".coupon .w-coupon-form").slideToggle();

    });

    // Remove colon(:) from "Par PayPal :" text
    var bankDiv = $('#bank_div');
    var bankTitle = bankDiv.find('.wrapper_bloc_banque.paypal .bank_title span');

    if(bankTitle.length) {
        bankTitle.find('b').remove();

        var bankTitleTxt = bankTitle.text();

        bankTitle.html(bankTitleTxt.replace(/:/g, '').trim());
    }

    // Fiche produit zoomBox
    if ($("#zoomBox.lightbox").css('display') == 'block'){
        $('body').css('overflow', 'hidden')
    }

    window.addEventListener("load", updateCurrentNav);
    window.addEventListener("scroll", updateCurrentNav);

    /* Input file -- attachment */

    var $input = $('#filepj1'),
        $label   = $input.prev( 'label.ajout_pj_label' ),
        labelVal = $label.text().replace(/\s:/i, ""),
        closePJ = $input.closest('.file-input-row').next('.file-list').find('.rowList .closePj#reset_file1');

    // set PJ label text
    $label.html(labelVal);

    $input.on( 'change', function( e )
    {
        var fileName = '';

        closePJ.on('click', function(e) {
            $label.html( labelVal );
        });

        if( e.target.value ) {
            fileName = e.target.value.split( '\\' ).pop();
            $label.addClass('has_pj');
        }
        else {
            if($label.hasClass('has_pj')) {
                $label.removeClass('has_pj');
            }
        }

        if( fileName )
            $label.html( fileName );
        else
            $label.html( labelVal );
    });

    if($('#cart_total .bill_line.total').length && !$('body').hasClass('customer')){
        $('.bill_line.delay_information').insertAfter($("#cart_total .bill_line.total")).show();
    }

    // Masquer l'entrée A propos au scroll

    var menuApropos = $('.menu_categ_wrapper .menu_static');
    $(window).scroll(function() {

        if ($(this).scrollTop() > 0) {
            menuApropos.fadeOut(1000);
        } else {
            menuApropos.fadeIn(1000);
        }
    });

    if ($('.tgCms').length) {

        var journalModuleSwiper = new Swiper( ".tgCms.swiper", {
            slidesPerView: 4,
            loop: false,
            spaceBetween: 12,
            navigation: {
                nextEl: ".cmstg-button-next",
                prevEl: ".cmstg-button-prev",
            },
            on: swiperLazyEvents
        } );
    }

    if ($('#articles_list_swiper').length) {
        var swiperArticleModule = new Swiper( "#articles_list_swiper", {
            slidesPerView: 2,
            loop: false,
            spaceBetween: 30,
            navigation: {
                nextEl: ".articles-list-swiper-button-next",
                prevEl: ".articles-list-swiper-button-prev",
            },
            on: swiperLazyEvents
        });
    }

    var container_other_information = $('.cart.fr .main_wrapper #container_other_information');

    if (container_other_information.length) {
        if ($(".cart_main_table.wishlist.dropper .cart_product_line").length > 0) {
            $(container_other_information).insertAfter("#right_col_sticky .bloc_question");
            container_other_information.addClass('with_wishlist');
            $('.cart.fr .main_wrapper #container_other_information .container_logo_other_information').addClass('with_wishlist');
            $(container_other_information,'.with_wishlist').css('display', 'block');
        } else {
            container_other_information.css('display', 'flex');
        }

        scrollToDonationBox();
    }

    if ($('body').hasClass('cart') && $('body').hasClass('step_1')) {
        let originalBasketToWish = window.basketToWish;

        window.basketToWish = function() {
            if (typeof originalBasketToWish === 'function') {
                originalBasketToWish.apply(this, arguments);
                popupBasketToWish();
            }
        };
    }

    //Close lightbox
    $("#abox .form_submit .dark").click(function () {
        closeMultiShad('abox');
    });

    // Trigger overlayScrollbars when clicking on choice_store button
    setTimeout(function () {
        $('body').on('click', '.choice_store', function () {
            if ($('#availabilityInStoreForm #availability_form_wrapper').length) {
                $('#availabilityInStoreForm #availability_form_wrapper').overlayScrollbars({});
            }
        });
    }, 800);

    if ($('.product_page').length) {
        if ($('body').hasClass('fr')) {
            scrollPage(12);
        } else {
            scrollPage(7);
        }
        $(window).on('scroll', function () {
            onWinScrollColorBox();
        });
    }

    window.fpDescDetailsSwiperInstance = null;

    window.initFpDescDetailsSwiper = function() {
        var $container = $('#fpDescDetails');
        if (!$container.length) {
            return;
        }

        var $slides = $container.find('.swiper-slide');
        var totalWidth = 0;

        $slides.each(function() {
            totalWidth += $(this).outerWidth(true);
        });

        if (totalWidth > $container.width()) {
            // Détruire l'instance précédente si elle existe
            if (window.fpDescDetailsSwiperInstance) {
                window.fpDescDetailsSwiperInstance.destroy(true, true);
                window.fpDescDetailsSwiperInstance = null;
            }

            // Créer une nouvelle instance
            window.fpDescDetailsSwiperInstance = new Swiper('#fpDescDetails', {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.nextNavDesc',
                    prevEl: '.prevNavDesc',
                },
                on: {
                    init: function() {
                        var $currentSlide = $container.find('.swiper-slide.current');
                        if ($currentSlide.length && window.fpDescDetailsSwiperInstance) {
                            var slideIndex = $currentSlide.index();
                            window.fpDescDetailsSwiperInstance.slideTo(slideIndex, 0, false);
                        }
                    },
                    slideChange: function() {
                        var $currentSlide = $container.find('.swiper-slide.current');
                        if ($currentSlide.length) {
                            $currentSlide.removeClass('current');
                        }
                        var activeIndex = window.fpDescDetailsSwiperInstance.activeIndex;
                        $container.find('.swiper-slide').eq(activeIndex).addClass('current');
                    }
                }
            });

        } else {
            if (window.fpDescDetailsSwiperInstance) {
                window.fpDescDetailsSwiperInstance.destroy(true, true);
                window.fpDescDetailsSwiperInstance = null;
            }
        }
    };

    if ($('#fpDescDetails').length) {
        var $container = $('#fpDescDetails');

        function ensureCurrentSlideVisible() {
            var $currentSlide = $container.find('.swiper-slide.current');
            if ($currentSlide.length && window.fpDescDetailsSwiperInstance) {
                var slideIndex = $currentSlide.index();
                window.fpDescDetailsSwiperInstance.slideTo(slideIndex, 0, false);
            }
        }

        window.initFpDescDetailsSwiper();

        $(window).on('resize', function() {
            window.initFpDescDetailsSwiper();
            ensureCurrentSlideVisible();
        });

        $('#fpDescDetails').on('click', '.thumblnk', function(e) {
            e.preventDefault();

            var pannel = $(this).data('pannel');
            var navbar = $(this).closest('[data-navbar]').attr('data-navbar');

            // Mise à jour de l'onglet actif
            $container.find('.swiper-slide').removeClass('active current');
            $(this).closest('.swiper-slide').addClass('active current');

            // Mise à jour du panneau visible
            $(".thumbslide[data-navbar='" + navbar + "']").removeClass('actif current');
            $(".thumbslide[data-pannel='" + pannel + "'][data-navbar='" + navbar + "']").addClass('actif current');

            // Swiper : slide vers l'onglet cliqué
            if (window.fpDescDetailsSwiperInstance) {
                var slideIndex = $(this).closest('.swiper-slide').index();
                window.fpDescDetailsSwiperInstance.slideTo(slideIndex, 500, false);
            }
        });
    }


        // Country select init with select2
    $('#countries_select').select2({
        width: 'resolve',
        placeholder: Translator.translate('choose_country'),
        templateResult: function (data) {
            if (!data.id) {
                return data.text;
            }
            const $option    = $(data.element);
            const countryId  = $option.data('country-id');
            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-country-id', countryId);

            return $node;
        },
        templateSelection: function (data) {
            if (!data.id) {
                return data.text;
            }
            const $option    = $(data.element);
            const countryId  = $option.data('country-id');
            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-country-id', countryId);
            return $node;
        },
    });
    $('#countries_select').on('select2:open', function () {
        const $search = $('.select2-container .select2-search__field');
        $search.attr('placeholder', Translator.translate('search_country_placeholder'));
        setTimeout(function () {
            $search.trigger('focus');
        }, 100);
    });

    $('#country_langs_select').select2({
        minimumResultsForSearch: -1,
        width: 'resolve',
        templateResult: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option = $(data.element);
            const isDefault = $option.data('default');

            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-default', isDefault);

            return $node;
        },
        templateSelection: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option = $(data.element);
            const isDefault = $option.data('default');

            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-default', isDefault);

            return $node;
        },
    });

    // SW-19561 - handle #search=??? in home module
    document.querySelectorAll('.home-module a[href*="#search="]').forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Gets the href attribute
            const href = link.getAttribute("href");

            // Extracts the search value from the hash
            const match = href.match(/#search=([^&]+)/);

            if (match && match[1]) {
                const searchValue = match[1]; // ex : "sergent%20major"

                // Starts a search with the extracted value
                if (!window.wShop) {
                    console.error("wShop is not defined.");
                    return;
                }

                window.wShop.searchStr = searchValue;
                // Add also the search value in the search input if exists
                try {
                    $("#search_home").val(decodeURIComponent(searchValue));
                    applySearchClass();
                } catch (e) {
                    console.error("Error setting search input value:", e);
                }
                window.wShop.getProducts();
                document.addEventListener("search_getProducts_end", function () {
                    applySearchClass();
                }, { once: true });
            }
        });
    });

    // Close preheader
    var headerDelivery = $(".preheaderWrapper");
    $(".close_delais").on("click", function() {
        $("#site_head_wrap").removeClass("bandeau_on");
        headerDelivery.slideUp(500, function() {
            headerDelivery.remove();
        });
    });

    // internal-link-wrapper see more/see less functionality START //
    let internalLink = $('.internal-links');
    let voirPlusBtn = '#voir_plus_btn';

    if ($('.internal-links a').length > 1) {
        $('<div id="voir_plus_btn">' + Translator.translate('see_more') + '</div>').insertAfter('.internal-links');
    }

    $(voirPlusBtn).on('click', function() {
        if(!internalLink.hasClass('show-links')) {
            internalLink.addClass('show-links');
            $(voirPlusBtn).text(Translator.translate('see_less'));
        } else {
            internalLink.removeClass('show-links');
            $(voirPlusBtn).text(Translator.translate('see_more'));

            var $el = internalLink;
            if ($el.length) {
                $('html, body').animate({
                    scrollTop: $el.offset().top - (($(window).height()/2) + ($el.outerHeight()/2) - 300)
                }, 500);
            }
        }
    });
    // internal-link-wrapper see more/see less functionality END //
});

function applySearchClass() {
    let searchInputValue = $("#search_home").val();

    if (searchInputValue.length >= 3) {
        $('body').addClass('search_in');
    } else {
        $('body').removeClass('search_in');
    }
}

function scrollPage(vh) {
    const viewportHeight = window.innerHeight;
    const pixels = (vh / 100) * viewportHeight;
    $(window).scrollTop(pixels);
}

/*
function initProductSwiper() {
    if (!document.querySelectorAll(".productSwiper.swiper").length) return;

    document.querySelectorAll(".productSwiper.swiper").forEach(function(container) {
        var id = container.closest('.item').getAttribute('id');

        container.addEventListener('mouseenter', function handler() {
            if (container.classList.contains('swiper-initialized')) return;

            var slideOn = container.querySelector('.swiper-slide-on');

            if (slideOn && slideOn.classList.contains('cache')) {
                var wrapper = container.querySelector('.swiper-wrapper');
                wrapper.innerHTML = slideOn.innerHTML;
                container.querySelectorAll('.swiper-slide-off, .swiper-slide-on').forEach(function(el) {
                    el.remove();
                });
            }

            var swiper = new Swiper(container, {
                slidesPerView: 1,
                navigation: {
                    nextEl: '#' + id + ' .rollover_rayonsNext',
                    prevEl: '#' + id + ' .rollover_rayonsPrev',
                },
                on: {
                    init: function() {
                        loadVisibleImages(this);
                    },
                    slideChange: function() {
                        loadVisibleImages(this);
                    }
                }
            });

            container.removeEventListener('mouseenter', handler);
        });
    });
}

function loadVisibleImages(swiper) {
    var activeIndex = swiper.activeIndex;
    var slidesToLoad = [activeIndex];

    if (swiper.params.loadPrevNext) {
        if (activeIndex > 0) slidesToLoad.push(activeIndex - 1);
        if (activeIndex < swiper.slides.length - 1) slidesToLoad.push(activeIndex + 1);
    }

    slidesToLoad.forEach(function(index) {
        var slide = swiper.slides[index];
        if (!slide) return;

        slide.querySelectorAll('img[data-src]').forEach(function(img) {
            if (img.dataset.src && !img.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            }
        });
    });
}
*/

$(document).on("click", ".thumblnk", function(evt) {
    var id_pannel = this.getAttribute("data-pannel");
    var thumbnav = $(this).closest(".thumbnav");
    var thumbcnt = thumbnav.parent().next(".thumbcnt");

    evt.preventDefault();

    thumbnav
        .find(".thumblnk")
        .not(".thumblnk[data-pannel=" + id_pannel + "]")
        .removeClass("current");
    thumbcnt
        .find(".thumbslide")
        .not(".thumbslide[data-pannel=" + id_pannel + "]")
        .removeClass("current");

    thumbnav
        .find(".thumblnk[data-pannel=" + id_pannel + "]")
        .addClass("current");
    thumbcnt
        .find(".thumbslide[data-pannel=" + id_pannel + "]")
        .addClass("current");
});

// Isolate use strict to avoid interference with other scripts
$(function () {
    'use strict';
    $("#cart_list").lionbars();
    $("#cart_top").on('mouseenter touchstart', function (evt) {
        $("#cart_list").lionbars();
    });
});

function onWinScrollColorBox() {
    var selectors = ['#show_all_colors_lightbox', '#color_list_wrapper', '#size_list_wrapper'];
    var elements = $(selectors.join(','));

    // check if at least one element exists
    if (!elements.length) {
        return;
    }

    var scrollTop = $(document).scrollTop();
    var isSticky = scrollTop >= 1;

    elements.toggleClass('sticky', isSticky);
}

/**
 * Pour afficher le panier sur le coté (utilisé aussi dans product.js à l'ajout du panier)
 */
function topProductAppear(elem) {
    var show_top = $('.cart_box',elem);
    if (!show_top.hasClass("appear") && $.trim(show_top.html())!='') {
        $(".cart_product_listing",elem).lionbars();
        show_top.addClass("appear");
        $('.connexion_top').removeClass("appear");
        $('#shad_menu').addClass("actif rollPanier");
        //Enable apple pay button in basket rollover (disabled on product page due to the other button having the same id)
        $('#show_top_cart #applepay_express_checkout').removeClass('disabled');

        // If a side lightbox is currently open, close it
        if ($('.sidebox.actif').length) {
            closeMultiShad($('.sidebox.actif').attr('id'));
        }
    }
}

/**
 * Pour afficher le panier sur le coté (utilisé aussi dans product.js à l'ajout du panier)
 */
function topProductDesappear() {
    var show_top = $('.cart_box');
    if (show_top.hasClass("appear")) {
        show_top.removeClass("appear");
        $('#shad_menu').removeClass("actif rollPanier");
    }
}

function closeRecherche(){
    $(".wrap_search_field").fadeOut();
    $("body").removeClass("search");
    $("#trigger_recherche").css("opacity", "1");
    $("#shad_menu").removeClass("actif_search");
    if ($(window).scrollTop() <= 30) {
        $("#site_head_wrap").removeClass("sticky");
    }
}

$('#search_home').keypress(function (e) {
    var key = e.which;

    if(key == 13 && $('#search_home').val().length >= 3){
        closeRecherche();
    }
});

function btnLoaderTrigger(evt) {
    "use strict";

    var element = $(this);
    var loader = $(this).last(".loader");

    if (loader.length > 0) {
        // Hipay submit was completely blocked on desktop without this. Be careful to make a payment test if you remove the condition.
        if (element.attr('id') != 'hipay-3-submit-button' && !document.getElementsByClassName('store_locator_page')) {
            evt.preventDefault();
        }

        loader.removeAttr("style").parent().addClass("loading");

        setTimeout(function () {
            loader.parent().removeClass("loading");
        }, 1200);

        // in the case that the element has an href, we redirect to it
        var href = $(this).attr("href");
        if (href && href != '#' && href != 'javascript:void(0)') {
            window.location.href = href;
        }

        // Dans le cas où il y a plusieurs bouton  en loading
        window.setTimeout(function() {
            $('.form_submit.loading').removeClass('loading')
        }, 5000);
    }
}

var nav_UA = window.navigator.userAgent.split('/'),
    nav_ver = parseFloat(nav_UA.pop()),
    nav_name = nav_UA.pop();

var id_select = '';

// -----------------------------------------------------------------

// Vérification d'un bouton radio
function verif_radio(elementID, fieldname) {

    "use strict";
    if (elementID == 'clientCiviliteM' || elementID == 'clientCiviliteMme' || elementID == 'clientCiviliteMlle') {

        elementID = 'clientCivilite';
    }

    var objElement = document.getElementsByName(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    var trouve = false;
    var t_error = null;

    $(objElement).removeData('data-error-text').removeAttr('data-error-text');

    if (elementID) {

        $("input[name='" + elementID + "']").each(function (idx) {

            if ($(this).is(':checked') == true) {

                objElement.className = 'inputForm';
                trouve = true;
            }
        });

        if (!trouve) {

            if (elementID == 'clientCivilite') {

                t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_error_civilite&arg2=' + fieldname);
            } else {

                t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_error_thanks&arg2=' + fieldname);
            }

            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        } else {

            $(objElement).removeClass('inputErr');
            $(objLabel).removeClass('labelErr');
        }
    }
    return true;
}

function verif_price(e, t) {

    "use strict";

    var a = document.getElementById(e),
        r = document.getElementById(e + "Label"),
        l = (document.getElementById("mes_err_fieldset"), document.getElementById("erreur_msg"));

    if ($(a).removeData("data-error-text").removeAttr("data-error-text"), "" == a.value) return t_error = '<p class="title_toolltip">' + ajax_file("ajax_sprintf.php?arg1=" + t) + " :</p>" + ajax_file("ajax_sprintf.php?arg1=js_thanks_precise&arg2=" + t), $(a).data("data-error-text", t_error), l.innerHTML = t_error, a.className = "inputErr", r.className = "labelErr", !1;

    var n = validate_price(a.value);

    return 0 == n ? (t_error = '<p class="title_toolltip">' + ajax_file("ajax_sprintf.php?arg1=" + t) + " :</p>" + ajax_file("ajax_sprintf.php?arg1=js_thanks_precise&arg2=" + t), $(a).data("data-error-text", t_error), l.innerHTML = t_error, a.className = "inputErr", r.className = "labelErr", !1) : (a.className = "inputForm", r.className = "labelForm", !0)
}

function validate_price(e) {
    return /^[\d\.,]+$/.test(e)
}

function verif_zip(elementZipID, elementCountryID, fieldname, nb) {
    var objZipElement = document.getElementById(elementZipID);
    var objCountryElement = document.getElementById(elementCountryID);
    var objLabel = document.getElementById(elementZipID + 'Label');
    var erreurFieldset = document.getElementById('mes_err_fieldset');
    var erreurText = document.getElementById('erreur_msg');

    var idPays = objZipElement.value.substr(0, 2);

    if (objCountryElement.value == "DO" && idPays != '97') {

        erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_error_zip_special_1&arg2=' + fieldname + '&arg3=97');
        $(objZipElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    } else if (objCountryElement.value == "MO" && idPays != '98') {

        erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_error_zip_special_1&arg2=' + fieldname + '&arg3=98');
        $(objZipElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    } else if (objCountryElement.value == "TO" && idPays != '97' && idPays != '98') {

        erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_error_zip_special_1&arg2=' + fieldname + '&arg3=97ou98');
        $(objZipElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    } else if ((objCountryElement.value != "DO" && objCountryElement.value != "TO" && objCountryElement.value != "MO") && (idPays == '97' || (idPays == '98' && objCountryElement.value != "FR"))) {

        erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_error_zip_special_2&arg2=' + fieldname + '&arg3=' + idPays);
        $(objZipElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    }

    $(objZipElement).removeClass('inputForm');
    $(objLabel).removeClass('labelErr');
    return true;
}

function verif_num(elementID, fieldname, nb) {
    var flg = 0;
    var num = "0123456789.,";
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    var point = 0;
    var virgule = 0;

    if (objElement.value == "") {
        erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_thanks_precise&arg2=' + fieldname);
        $(objElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');

        return false;
    } else {
        if (objElement.value.length < nb) {
            erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_at_least_x_digits&arg2=color:red;&arg3=' + fieldname + '&arg4=' + nb);
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        }
        for (var k = 0; k < objElement.value.length; k++) {
            var test = objElement.value.substring(k, k + 1);
            if (num.indexOf(test) < 0)
                flg++;
        }
        if (flg > 0) {
            erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_wrong_input_num&arg2=' + fieldname);
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            flg = 0;
            return false;
        }
        for (var k = 0; k < objElement.value.length; k++) {
            var test = objElement.value.substring(k, k + 1);
            if (test == '.') {
                point = point + 1;
            }
            if (test == ',') {
                virgule = virgule + 1;
            }
        }
        var tot = point + virgule;
        if (point > 1 || virgule > 1 || tot > 1) {
            erreurText.innerHTML = erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_wrong_input_num&arg2=' + fieldname);
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            flg = 0;
            return false;
        }

    }
    $(objElement).removeClass('inputErr');
    $(objElement).removeClass('labelErr');
    return true;
}

function verif_portable(elementID, fieldname) {
    return verif_telephone(elementID, fieldname, true);
}

function verif_telephone(elementID, fieldname, is_mobile) {

    var objElementHidden = document.getElementById(elementID + 'Hidden');
    var objElement = document.getElementById(elementID);
    var erreurText = document.getElementById('erreur_msg');

    if (objElementHidden !== null) {

        var value = $(objElement).intlTelInput("getNumber");
        var type = $(objElement).intlTelInput("getNumberType");

        if (value.length == 12 && value.substr(1, 3) == '337') {

            if (elementID === 'clientTel') {

                $('#clientMobileHidden').val(value);
            } else if (elementID == 'telephone') {

                $('#mobileHidden').val(value);
            } else if (elementID == 'billtelephone') {

                $('#billmobileHidden').val(value);
            } else if (elementID == 'candidatTel') {

                $('#candidatTelHidden').val(value);
            }
        } else {
            if ($(objElement).intlTelInput("isValidNumber") !== false && (type === 0 || type === 2 || type === 3 || type === 6)) {

                $(objElementHidden).val(value);
            } else if ($(objElement).intlTelInput("isValidNumber") !== false && type === 1) {

                if (elementID === 'clientTel') {

                    $('#clientMobileHidden').val(value);
                } else if (elementID == 'telephone') {

                    $('#mobileHidden').val(value);
                } else if (elementID == 'billtelephone') {

                    $('#billmobileHidden').val(value);
                } else if (elementID == 'candidatTel') {

                    $('#candidatTelHidden').val(value);
                }
            }
        }

        if ($(objElement).intlTelInput("isValidNumber") === false) {

            $(objElement).addClass('inputErr');

            return false;
        }

        $(objElement).removeClass('inputErr');

        return true;
    }

    if ($.trim($(objElement).val()).length > 0) {

        if ($(objElement).intlTelInput("isValidNumber") === false || ((is_mobile && $(objElement).intlTelInput("getNumberType") === 0)) || (is_mobile == false && $(objElement).intlTelInput("getNumberType") === 1)) {

            if (is_mobile && $(objElement).intlTelInput("getNumberType") === 0) {

                erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg2=' + fieldname + '_mobile') + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_error_mobile&arg2=' + fieldname);
            } else {

                erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg2=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_error_phone&arg2=' + fieldname);
            }

            return false;
        } else {

            $(objElementHidden).val($(objElement).intlTelInput("getNumber"));
        }

        return true;
    }

    $(objElement).addClass('inputErr');

    return false;
}

function verif_empty(elementID, fieldname) {
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    $(objElement).removeData('data-error-text').removeAttr('data-error-text');
    if (objElement.value == "") {
        t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_thanks_precise&arg2=' + fieldname);
        erreurText.innerHTML = t_error;
        $(objElement).data('data-error-text', t_error);
        $(objElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        $(objElement).removeClass('inputForm');
        $(objLabel).removeClass('labelForm');
        return false;
    }
    $(objElement).addClass('inputForm');
    $(objLabel).addClass('labelForm');
    $(objElement).removeClass('inputErr');
    $(objLabel).removeClass('labelErr');
    return true;
}

function verif_alphanum(elementID, fieldname, isMin, length) {
    var flg = 0;
    var alphanum = decodeURIComponent("%C2%B0") + "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ\,\'\"\-_/\.<>\n\r()%:; " + decodeURIComponent("%C3%A2%C3%A0%C3%A4%C3%A9%C3%A8%C3%AB%C3%AA%C3%AC%C3%AF%C3%AE%C3%B6%C3%B4%C3%B2%C3%B9%C3%BC%C3%BB%C3%A7&%C3%84%C3%82%C3%80%C3%89%C3%88%C3%8B%C3%8A%C3%8C%C3%8F%C3%8E%C3%96%C3%94%C3%92%C3%99%C3%9C%C3%9B%C3%87");
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    $(objElement).removeData('data-error-text').removeAttr('data-error-text');
    if (objElement.value == "") {
        t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_thanks_precise&arg2=' + fieldname);
        $(objElement).data('data-error-text', t_error);
        erreurText.innerHTML = t_error;
        $(objElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    } else {
        var space_after = objElement.value.lastIndexOf(" ");
        var space_before = objElement.value.indexOf(" ");
        if ((((space_after + 1) == objElement.value.length) || ((space_before + 1) == 1)) && (objElement.value.length <= 3)) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_at_least_n_chars_space&arg2=' + fieldname + '&arg3=3');
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        }
        if (isMin == false && objElement.value.length < 3) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_at_least_n_chars&arg2=3&arg3=' + fieldname);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        }
        for (var k = 0; k < objElement.value.length; k++) {
            var test = objElement.value.substring(k, k + 1);

            if (alphanum.indexOf(test) < 0) {
                flg++;
            }
        }
        if (flg > 0) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_wrong_input_alphanum&arg2=' + fieldname);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            flg = 0;
            return false;
        }
        if (isMin == true && objElement.value.length > length) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_too_long_alphanum&arg2=' + fieldname + '&arg3=' + length);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        }
    }
    $(objElement).removeClass('inputErr');
    $(objLabel).removeClass('labelErr');
    return true;
}

function verif_alphanumadresse(elementID, fieldname, isMin, length) {
    var flg = 0;
    var alphanum = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ\,\'\"_/\.<>\n\r()%:; " + decodeURIComponent("%C3%A2%C3%A0%C3%A9%C3%A8%C3%AB%C3%AAi%C3%AF%C3%AE%C3%B6%C3%B4%C3%B9%C3%BC%C3%BB%C3%A7%26%C3%84%C3%82%C3%80%C3%89%C3%88%C3%8B%C3%8AI%C3%8F%C3%8E%C3%96%C3%94%C3%99%C3%9C%C3%9B%C3%87%3F!%E2%82%AC-");
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    $(objElement).removeData('data-error-text').removeAttr('data-error-text');
    if (objElement.value == "") {
        t_error = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_thanks_precise&arg2=' + fieldname);
        $(objElement).data('data-error-text', t_error);
        erreurText.innerHTML = t_error;
        objElement.className = 'inputErr';
        if (objLabel)
            objLabel.className = 'labelErr';
        return false;
    } else {
        var space_after = objElement.value.lastIndexOf(" ");
        var space_before = objElement.value.indexOf(" ");
        if ((((space_after + 1) == objElement.value.length) || ((space_before + 1) == 1)) && (objElement.value.length <= 3)) {
            t_error = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_at_least_n_chars_space&arg2=' + fieldname + '&arg3=3');
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            objElement.className = 'inputErr';
            if (objLabel)
                objLabel.className = 'labelErr';
            return false;
        }
        if (isMin == false && objElement.value.length < 3) {
            t_error = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_at_least_n_chars&arg2=3&arg3=' + fieldname);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            objElement.className = 'inputErr';
            if (objLabel)
                objLabel.className = 'labelErr';
            return false;
        }
        for (var k = 0; k < objElement.value.length; k++) {
            var test = objElement.value.substring(k, k + 1);

            if (alphanum.indexOf(test) < 0)
                flg++;
        }
        if (flg > 0) {
            t_error = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_wrong_input_alphanum&arg2=' + fieldname);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            objElement.className = 'inputErr';
            if (objLabel)
                objLabel.className = 'labelErr';
            flg = 0;
            return false;
        }
        if (isMin == true && objElement.value.length > length) {
            t_error = '<p class="title_toolltip">' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file(path_relative_root + 'ajax_sprintf.php?arg1=js_too_long_alphanum&arg2=' + fieldname + '&arg3=' + length);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            objElement.className = 'inputErr';
            objLabel.className = 'labelErr';
            return false;
        }
    }
    objElement.className = 'inputForm';
    if (objLabel)
        objLabel.className = 'labelForm';
    return true;
}

function verif_mail(elementID, fieldname, is_spe) {

    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    var mail = new RegExp("^[a-z0-9_-]+([.]?[a-z0-9_-]{1,})*@([a-z0-9_-]{2,}[.])+[a-z]{2,4}$", "gi");

    path = '';
    if (typeof (path_relative_root) != 'undefined')
        path += path_relative_root;

    if (mail.exec(objElement.value) == null) {
        if (typeof (is_spe) == 'undefined') {
            var translations = ajax_file(path + 'ajax_sprintf.php?arg0=%s|%s' +
                '&arg1=' + fieldname +
                '&arg2=js_wrong_input_mail'
            );
            translations = translations.split("|");
            type_champ = translations[0];
            type_message = translations[1];

            erreurText.innerHTML = '<p class="title_toolltip">' + type_champ + ' :</p>' + type_message;
        }
        $(objElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;

    }
    $(objElement).removeClass('inputErr');
    $(objLabel).removeClass('labelErr');
    return true;
}

function verif_alpha(elementID, fieldname) {
    var flg = 0;
    var alphanum = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ,'\"-_/.ééÈèËëÊêÔôÎîÛûÂâÏïÄÖöäÜüÀàÙùÇç&n " + decodeURIComponent("%C3%A0%C3%A9%C3%A8%C3%AB%C3%AAi%C3%AF%C3%AE%C3%B6%C3%B4%C3%B9%C3%BC%C3%BB%C3%A7%C3%A4%C3%84%C3%82%C3%80%C3%89%C3%88%C3%8B%C3%8AI%C3%8F%C3%8E%C3%96%C3%94%C3%99%C3%9C%C3%9B%C3%87%C2%A0 ");
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    $(objElement).removeData('data-error-text').removeAttr('data-error-text');
    if (objElement.value == "") {
        t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_thanks_precise&arg2=' + fieldname);
        $(objElement).data('data-error-text', t_error);
        erreurText.innerHTML = t_error;
        $(objElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    } else {
        var space_after = objElement.value.lastIndexOf(" ");
        var space_before = objElement.value.indexOf(" ");
        if ((((space_after + 1) == objElement.value.length) || ((space_before + 1) == 1)) && (objElement.value.length <= 2)) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_at_least_n_chars_space&arg2=' + fieldname + '&arg3=2');
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        }
        if (objElement.value.length < 2) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_at_least_n_chars&arg2=2&arg3=' + fieldname);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            return false;
        }
        for (var k = 0; k < objElement.value.length; k++) {
            var test = objElement.value.substring(k, k + 1);
            if (alphanum.indexOf(test) < 0)
                flg++;
        }
        if (flg > 0) {
            t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_wrong_input_alpha&arg2=' + fieldname);
            $(objElement).data('data-error-text', t_error);
            erreurText.innerHTML = t_error;
            $(objElement).addClass('inputErr');
            $(objLabel).addClass('labelErr');
            flg = 0;
            return false;
        }
    }
    $(objElement).removeClass('inputErr');
    $(objLabel).removeClass('labelErr');
    return true;
}

function verif_selected_date(elementID, fieldname) {
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    var objElementJ = document.getElementById(elementID + 'J');
    var objElementM = document.getElementById(elementID + 'M');
    var objElementA = document.getElementById(elementID + 'A');
    if (objElementJ && objElementM && objElementA) {

        erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_thanks_precise&arg2=' + fieldname);
        var error = false;
        if (objElementJ.value == "") {
            error = true;
            $(objElementJ).addClass('inputErr');
        } else {
            $(objElementJ).removeClass('inputErr');
        }
        if (objElementM.value == "") {
            error = true;
            $(objElementM).addClass('inputErr');
        } else {
            $(objElementM).removeClass('inputErr');
        }
        if (objElementA.value == "") {
            error = true;
            $(objElementA).addClass('inputErr');
        } else {
            $(objElementA).removeClass('inputErr');
        }
        if (!error) {
            $(objLabel).removeClass('labelErr');
            return true;
        } else {
            $(objLabel).addClass('labelErr');
            return false;
        }
    }
    return true;
}

function preg_replace(array_pattern, array_pattern_replace, my_string) {
    var new_string = String(my_string);
    for (i = 0; i < array_pattern.length; i++) {
        var reg_exp = RegExp(array_pattern[i], "gi");
        var val_to_replace = array_pattern_replace[i];
        new_string = new_string.replace(reg_exp, val_to_replace);
    }
    return new_string;
}

function verifSame(field1, field2, fieldname) {
    var objElement = document.getElementById(elementID);
    var objLabel = document.getElementById(elementID + 'Label');
    var erreurText = document.getElementById('erreur_msg');
    $(objElement).removeData('data-error-text').removeAttr('data-error-text');
    if (document.getElementById(field1).value != document.getElementById(field2).value) {
        var txt_lang = (fieldname == 'login_email_verif') ? 'js_same_email_confirm' : 'js_same_mdp_confirm';
        t_error = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1=' + fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=' + txt_lang + '&arg2=' + fieldname);
        $(objElement).data('data-error-text', t_error);
        erreurText.innerHTML = t_error;
        $(objElement).addClass('inputErr');
        $(objLabel).addClass('labelErr');
        return false;
    }
    $(objElement).removeClass('inputErr');
    $(objLabel).removeClass('labelErr');
    return true;
}

function isClosedDay(day, month) {
    var array_closed_array = new Array('1/1', '25/4', '1/5', '8/5', '2/6', '13/6', '14/7', '15/8', '1/11', '11/11', '25/12', '26/12');
    return array_closed_array.in_array(day + '/' + month);
}

function changeVisu(field, path, evt) {

    var new_img, target, current;

    if (evt) {

        target = evt.target.parentElement;
        current = target.parentElement.getElementsByClassName("current");

        target.classList.add("current");

        Array.prototype.slice.call(current).forEach(function (elm) {

            if (elm !== target) {

                elm.classList.remove("current");
            }
        });
    }

    if (field && field.parentElement) {

        new_img = new Image();

        new_img.id = field.id;
        new_img.className = field.className;

        new_img.addEventListener('load', function () {

            this.alt = field.alt;

            this.setAttribute('width', this.naturalWidth);
            this.setAttribute('height', this.naturalHeight);

            if (field.parentElement) {

                field.parentElement.appendChild(this);
                field.parentElement.removeChild(field);
            }
        });

        new_img.src = path;
    }
    // Simpler way doesn't seem to work well with lazyloader
    // return document.getElementById(field).src = path;
}

function getPos(obj) {
    var pos = {x: obj.offsetLeft || 0, y: obj.offsetTop || 0};
    while (obj = obj.offsetParent) {
        pos.x += obj.offsetLeft || 0;
        pos.y += obj.offsetTop || 0;
    }
    return pos;
}

function closeInfobulle(id) {
    if (!jQuery.browser.msie) $("#" + id).fadeOut(400);
    else document.getElementById(id).style.display = 'none';
    document.getElementById(id).style.zIndex = '0';
}

var one_time = false;

function openInfobulle(id, type, elem) {
    window.clearTimeout(timer);
    $("#bloc_erreur").css('display', 'none');
    if (!jQuery.browser.msie) $("#bloc_erreur").stop(false, true).fadeOut();
    if (!jQuery.browser.msie) $("#" + id).fadeIn(400);
    else document.getElementById(id).style.display = 'block';
    if (typeof (type) != 'undefined') {
        var margin_spe_left = 0;
        var margin_spe_top = 0;
        if (elem.nodeName == 'SELECT') {
            id = elem.id.substr(0, elem.id.length - 1);
            if (id == 'clientMailAuth' || id == 'clientPwdAuth' || id == 'mailLost') {
                var txt_spe = document.getElementById(id + 'ErrErr').innerHTML;
                margin_spe_left = 300;
                if (id == 'clientPwdAuth')
                    margin_spe_top = 10;
                infos_alias
            } else if (type == 'banque')
                var txt_spe = document.getElementById('infos_carte').innerHTML;
            else if (type == 'alias_banque')
                var txt_spe = document.getElementById('infos_alias').innerHTML;
            else
                var txt_spe = document.getElementById(id + 'Err').innerHTML;
        } else {
            if (elem.id == 'clientMailAuth' || elem.id == 'clientPwdAuth' || elem.id == 'mailLost') {
                if (document.getElementById(elem.id + 'ErrErr'))
                    var txt_spe = document.getElementById(elem.id + 'ErrErr').innerHTML;
                if (elem.id == 'mailLost')
                    margin_spe_left = -350;
                else
                    margin_spe_left = -340;
                if (elem.id == 'clientPwdAuth')
                    margin_spe_top = 41;
                else
                    margin_spe_top = 4;
            } else if (type == 'banque')
                var txt_spe = document.getElementById('infos_carte').innerHTML;
            else if (type == 'alias_banque')
                var txt_spe = document.getElementById('infos_alias').innerHTML;
            else
                var txt_spe = document.getElementById(elem.id + 'Err').innerHTML;
        }
        document.getElementById('erreur_msg').innerHTML = txt_spe;
        pos = getPos(elem);
        document.getElementById('bloc_erreur').style.position = 'absolute';
        if (type == 'banque') {
            margin_spe_left -= 42;
            margin_spe_top += 30;
        } else if (type == 'alias_banque') {
            margin_spe_left -= 42;
            margin_spe_top += 15;
        }
        document.getElementById('bloc_erreur').style.top = pos.y - (document.getElementById('bloc_erreur').offsetHeight + margin_spe_top - 2) + 'px';
        pos_left_margin = getPos(document.getElementById('content'));
        left_add = 0;
        if (document.getElementById('wrapper_anniversaire_jour1')) {
            left_add = document.getElementById('bloc_erreur').offsetWidth;
            left_add -= 35;
        }
        document.getElementById('bloc_erreur').style.left = (pos.x + (elem.offsetWidth - 8) + margin_spe_left + 27 - left_add) + 'px';
        if (type == 'banque' || type == 'alias_banque') {
            document.getElementById('bloc_erreur').style.width = '280px';
        } else {
            document.getElementById('bloc_erreur').style.width = '280px';
        }
        document.getElementById('bloc_erreur').style.zIndex = '10000';
    }
}

function OverPopup(elem, msg, type, is_vp) {
    clearTimeout(timer);

    if (type == 'visible') {
        if (typeof (is_vp) != 'undefined' && is_vp != 'cmpid_adwords') {
            $("#bloc_erreur_vp").css('display', 'none');
            if (!jQuery.browser.msie) {
                $("#bloc_erreur_vp").stop(false, true).fadeOut();
            }
            if (!jQuery.browser.msie) {
                $("#bloc_erreur_vp").fadeIn(400);
            } else {
                document.getElementById('bloc_erreur_vp').style.display = 'block';
            }
        } else {
            if (!document.getElementById('formAnniversaire') || (document.getElementById('formAnniversaire') && elementID != 'newsletterMailv' && elementID != 'newsletterMailInscrit')) {
                pos = getPos(elem);
                document.getElementById('erreur_msg').innerHTML = msg;
                if (!jQuery.browser.msie) {
                    $("#bloc_erreur").stop(true, true).fadeIn(400);
                } else {
                    document.getElementById('bloc_erreur').style.display = 'block';
                }
                document.getElementById('bloc_erreur').style.position = 'absolute';
                pos_left_margin = -13;
                var left_add = 17;
                if (document.getElementById('wrapper_anniversaire_jour1')) {
                    left_add = document.getElementById('bloc_erreur').offsetWidth;
                    left_add -= 35;
                }
                if (document.getElementById('formAnniversaire')) {
                    left_add = $('#erreur_msg').width() - 10;
                    $(".bottom_tooltip").attr('align', 'right');
                }
                document.getElementById('bloc_erreur').style.left = (pos.x + (elem.offsetWidth - 8) - pos_left_margin - left_add) + 1 + 'px';
                if (is_vp === 'cmpid_adwords') {
                    var clone = $('#bloc_erreur').clone(),
                        c_pos = {
                            top: $(elem).offset().top - $(elem).offsetParent().offset().top - $('#bloc_erreur').height() + 4,
                            left: $(elem).offset().left - $(elem).offsetParent().offset().left - $('#bloc_erreur').innerWidth() + ($(elem).width() * 2) + 6
                        };
                    $('#bloc_erreur').remove();
                    $(elem).after(clone);
                    $('#bloc_erreur').find('td:nth-child(2)').children('img').css({
                        'float': 'right',
                        'margin': '0 7px'
                    });
                    $('#bloc_erreur').css({
                        'position': 'absolute',
                        'top': c_pos.top,
                        'left': c_pos.left,
                        'z-index': '99999',
                        'opacity': '1'
                    });
                } else {
                    document.getElementById('bloc_erreur').style.top = (pos.y - document.getElementById('bloc_erreur').offsetHeight) + 'px';
                }
                if (elem.id == "departement_naissance") {
                    $('#bloc_erreur').css({"width": 180, "marginTop": 63, "marginLeft": -310});
                }
                document.getElementById('bloc_erreur').style.zIndex = '99999';
            }
        }
    } else {
        if (typeof (is_vp) != 'undefined' && is_vp != 'cmpid_adwords') {
            if (!jQuery.browser.msie) {
                $("#bloc_erreur_vp").fadeOut(400);
            } else {
                document.getElementById('bloc_erreur_vp').style.display = 'none';
            }
            document.getElementById('bloc_erreur_vp').style.zIndex = '0';
        } else {
            if (!jQuery.browser.msie) {
                $("#bloc_erreur").stop(true, true).fadeOut(400);
            } else {
                document.getElementById('bloc_erreur').style.display = 'none';
            }
            document.getElementById('bloc_erreur').style.zIndex = '0';
        }
    }
}

/**
 * Returns the specified computed style on an object.
 * @param {HTMLObject} obj HTML Object
 * @param {String} styleProp Property name.
 * @return {Mixed} Computed style on object.
 */

/* pour les questions du panier panier */
function fadePanier(id, nbelem) {

    for (var i = 1; i <= nbelem; i++) {

        if (id != i && $("#texte_question_" + i).css('display') == 'block') {

            $("#texte_question_" + i).slideUp(400);
            $("#intitule_question_" + i).removeClass('actif');
        }
    }

    if ($("#texte_question_" + id).css('display') != 'block') {

        $("#texte_question_" + id).slideDown(400);
        $("#texte_question_" + id).addClass('actif');
        $("#intitule_question_" + id).addClass('actif');
    } else {

        $("#texte_question_" + id).slideUp(400);
        $("#texte_question_" + id).removeClass('actif');
        $("#intitule_question_" + id).removeClass('actif');
    }
}

function triggerFunctionOnSearchEnd() {
    //initProductSwiper();
    initializeItemSliders();
}

function triggerDropdown(elem, trigger, toDrop) {
    $(elem).toggleClass('actif');
    $(elem).find(toDrop).toggleClass('actif');
    $(".filters_container_wrapper").overlayScrollbars({});
}

/* showblocform */
function showBlocForm(id, type) {

    clearTimeout(timer);

    if ($('#bloc_erreur').css('display') == 'table' || $('#bloc_erreur').css('display') == 'block') {

        $('#bloc_erreur').css('display', 'none');
    }

    if (id == 'is_not_client') {

        $(".wrapper_login.left").addClass('actif');
        $(".wrapper_login.right").removeClass('actif');

    } else if (id == 'is_client') {

        $(".wrapper_login.left").removeClass('actif');
        $(".wrapper_login.right").addClass('actif');
    }
}

/*
** gère l'affichage des mentions du formlaire
*/
$(document).on('wLostpassFormSuccess', function () {
    $('#subtitlePassword').css('display', 'none');
});

function afficheLostPasswordSubF() {
    var subtitleLegalNotices = $('.subtitle.legal_notices');
            subtitleLegalNotices.animate({
                opacity: 0
            }, 600, function () {
                subtitleLegalNotices.css('display', 'none');
            });
}

function reloadBlocLoginSubF() {
    var subtitleLegalNotices = $('.subtitle.legal_notices');
    subtitleLegalNotices.css('display', 'block').animate({
        opacity: 1
    }, 600);
}

function afficheLostPasswordTop() {

    if ($('#bloc_erreur').is(':visible')) {

        $('#bloc_erreur').css('display', 'none');
    }

    $("#is_client_form").hide();
    $("#lost_password_top").css({display: "block", opacity: 0}).fadeIn(600);
}

function reloadBlocLoginTop() {

    if ($('#bloc_erreur').is(':visible')) {

        $('#bloc_erreur').css('display', 'none');
    }

    $("#lost_password_top").hide();
    $("#returning_customer_top").fadeIn(600);
}

function show_lightbox_3xcb() {
    // Commenté et return car view masterisée
    return
}

function close_lightbox_3xcb() {
    closeMultiShad('popup_cofidis3cb');
}

function in_array(needle, haystack, strict) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: in_array('van', ['Kevin', 'van', 'Zonneveld']);
    // *     returns 1: key
    var rKey = -1, strict = !!strict;
    if (haystack.length > 0) {
        for (key in haystack) {
            if ((strict && haystack[key] === needle) || (!strict && haystack[key] == needle)) {
                rKey = key;
                break;
            }
        }
    }
    return rKey;
}

function in_array_js(needle, haystack) {
    var rKey = -1;
    if (haystack.length > 0) {
        for (key in haystack) {
            if (haystack[key] == needle) {
                rKey = key;
                break;
            }
        }
    }
    return rKey > -1 ? true : false;
}

$.fn.recalImg = function (img) {
    var obj = $(this);
    var img;
    if (img == "" || img == null) {
        img = $("img", obj);
    } else {
        img = $(img, obj);
    }
    img.css({position: "", height: "", width: "", left: "", top: "", marginTop: "", marginLeft: ""});
    var widthObj = obj.outerWidth(true);
    var heightObj = obj.outerHeight(true);
    var widthImg = img.width();
    var heightImg = img.width();
    obj.css({position: "relative"});
    img.css({position: "absolute"});
    if ((heightImg > heightObj) || (widthImg > widthObj)) {
        if (widthImg > heightImg) {
            img.css({height: heightObj});
        } else if (widthImg <= heightImg) {
            img.css({width: widthObj});
        }
        var widthImgNow = img.outerWidth(true);
        var heightImgNow = img.outerHeight(true);
        var difHeight = (heightObj - heightImgNow) / 2;
        var difWidth = (widthObj - widthImgNow) / 2;
        if (widthImg > heightImg) {
            img.css({left: 0, top: 0});
        } else if (widthImg <= heightImg) {
            img.css({top: 0, left: 0});
        }
    } else {
        img.css({top: "0", left: "0"});
    }
    img.show();
};

function showrecuppanierlightbox() {
    var elname = 'recuppanier';
    var actualposition = document.documentElement.scrollTop;
    var modbox = document.getElementById(elname);
    var topconnexion = document.getElementById('topMenuConnexionButtonInside');
    var shad = document.getElementById('shad2');
    shad.style.display = "block";
    modbox.style.display = "block";
    if (navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('7.') != -1) {
        topconnexion.style.zIndex = -1;
    }
    addEventPromo(shad, 'click', closerecuppanier);
    window.scrollTo(0, actualposition);
}

function closerecuppanier() {
    var modbox = document.getElementById('recuppanier');
    var shad = document.getElementById('shad2');
    modbox.style.marginLeft = '';
    shad.style.display = "none";
    modbox.style.display = "none";
    document.body.style.overflow = '';
    document.getElementsByTagName("html")[0].style.overflow = "";
    delEventPromo(shad, 'click', closerecuppanier);
}

function addEventPromo(event, name_function) {
    if (document.all) document.getElementById('shad').attachEvent("on" + event, name_function);
    else document.getElementById('shad').addEventListener(event, name_function, false);
}

function delEventPromo(event, name_function) {
    if (document.all) document.getElementById('shad').detachEvent("on" + event, name_function);
    else document.getElementById('shad').removeEventListener(event, name_function, false);
}

function addFileInput(id_input, string) {

    var field = (typeof (string) != 'undefined') ? string : 'contactProduitPhoto';
    id = parseInt(id_input);
    var next_file = id + 1;
    var file = $('#' + field + id_input)[0].files[0];
    var error = false;
    var input = field == 'contactProduitPhoto' ? $('#photoProduit_display') : $('#photoProduitEndommage_display');
    var nb_input = field == 'contactProduitPhoto' ? $(input).val() : $(input).val();
    nb_input = parseInt(nb_input);
    size = file.size;
    type = file.type;
    var allowedType = new Array('image/jpeg', 'image/png', 'application/pdf'); // Type de fichiers autorisés

     if (size > 4000000) {
        alertV2('Poids Max : 4Mo');
        error = true;
    } else if (jQuery.inArray(type, allowedType) == -1) {
        alertV2('Format autoris&eacute; : jpg, png, pdf');
        error = true;
    }

    if (error) {
        if (id_input == 1) {
            $('#field_send').addClass('cache');
            $('#' + field + next_file).remove();
        }
        $('#' + field + id_input).val('');
    } else {
        if (id_input == 1) {
            $('#field_send').removeClass('cache');
        }
        if (field != 'filepj') {
            var params = (typeof (string) != 'undefined') ? ',"' + string + '"' : '';
            var style = (typeof (string) != 'undefined' && string != 'contactProduitPhotoEndommage') ? 'style="float: left; padding-left: 32px;padding-top:-2px;"' : '';
            $('#' + field + id_input).after("<input " + style + " class='product_file' id='" + field + next_file + "' value='' type='file' name='" + field + next_file + "' onchange='addFileInput(" + next_file + params + ")' /> ");
            $(input).attr('value', next_file);
        } else {
            $('#' + field + id_input).parent().find(".file_msg p").text(file.name);
        }
    }
}

function deplieMsg(id) {
    $('.btn-deplier').removeClass('deplier-opened');
    $('.detail_message').slideUp();
    $('#conversation_msg_' + id).slideDown().parent().find('.btn-deplier').addClass('deplier-opened');
}

function changeLocale(locale, uri, redirect = true, siteId = 0) {
    $.ajax({
        url: path_relative_root + "ajax_get_uri_by_lang.php",
        type: "post",
        data: {lang: locale, url: uri, redirect: redirect, site: siteId},
        success: function (data) {
            if (data != "") {
                var force = "";
                if (uri == "/") {
                    force = "?force";
                }
                if (redirect) {
                    location.href = data + force;
                } else {
                    urlLang = data;
                }
            }
        },
    });
}

$.fn.selectChangeAdr = function () {
    var $obj = $(this);
    var obj_val = $obj.val();
    var id_transp = $obj.attr('id');
    var data = {};
    var $changeContainer = $('.wrapper_form_adresse', $obj.closest('.adresse_change'));
    data.act = 'ajout';
    data.id_transp = id_transp;
    data.no_encode_ajax = true;
    data.modif_type = 'ajax';

    if (obj_val != '') {

        if (obj_val != 0) {
            data.idAdresse = obj_val;
            data.act = 'modif';
        }
        if ($changeContainer.is('.show')) {
            $changeContainer.removeClass('show').slideUp().html('');
        }
        $.ajax({
            type: 'get',
            data: data,
            url: path_relative_root + 'livraison-ajax.php',
            success: function (response) {
                var $responce = $(response);
                var min_form = $('.min_form', $responce).html();
                var $form = $('#adresseForm', $responce);
                var all_form;

                $changeContainer.html($form.html(min_form)).css({display: 'none'}).slideDown();
                if (!$changeContainer.is('.show')) {
                    $changeContainer.addClass('show').slideDown()
                }
                try {
                    new DeliveryPage().init();
                } catch (e) {
                    console.log(e);
                }
                initialize_google_place('delivery');
                $('.type_adresse', '.choix_type_adresse.delivery').on('click', function () {
                    $(this).show_adresse_title($('.type_adresse', '.choix_type_adresse.delivery'), '#adresseTitre');
                });

                var country_select = '';

                if (typeof $("#pays").val() != 'undefined') {

                    country_select = $("#pays").find(":selected").data('role').toLowerCase();

                    $("#pays").change(function () {

                        if (typeof $(this).find(":selected").data('role') != 'undefined') {

                            country_select = $(this).find(":selected").data('role').toLowerCase();

                        }

                        if (typeof $("#telephone").val() != 'undefined') {

                            $("#telephone").intlTelInput("setCountry", country_select);

                        }

                        if (typeof $("#mobile").val() != 'undefined') {

                            $("#mobile").intlTelInput("setCountry", country_select);
                        }
                    });

                } else {
                    country_select = "fr";
                }
            }
        });
    }
};

(function () {

    "use strict";

    var stickyCnt = 0;

    function initStickies() {

        var stickies = document.getElementsByClassName("sticky");

        Array.prototype.slice.call(stickies).forEach(function (sticky) {

            if (sticky.id !== "site_head_wrap") {

                if (sticky.id === "") {

                    stickyCnt += 1;
                    sticky.id = "sticky-" + stickyCnt;
                }

                sticky = new ScrollLock(sticky.id);
            }
        });
    }

    $(initStickies);
}());

/* Enables hover state on any element when using a touch based device */
(function () {

    function nevermind() {

        return;
    }

    document.body.addEventListener("click", nevermind);
}());

/**
 * @description Recovers stock sizes by color and their stock
 *
 * @since 2022-11-04
 */
function setAvailableSizes() {
    let produit_id = $('#produit_principal').val();
    // SW-22321 : on demande les quantites reelles et non des booleens, pour piloter le message "Dernieres pieces"
    let data = {produit_id: new Array(produit_id), valueAsBool: 0};

    if (isGlobalEActive) {
        data.warehouse_only = 1;
    }

    // SW-22321 : le radio couleur n'est pas toujours coche au chargement, on retombe sur la couleur du produit
    let elem_id = $(this).val() || $('#couleurProd').val();

    $.ajax({
        url: path_relative_root + 'ajax_get_colisages_states_by_color_size.php',
        type: 'post',
        data: data,
        success: function (res) {
            try {
                res = $.parseJSON(res);
            } catch (e) {
                console.error("parseJSON");

                return;
            }

            if (res.success && res.result && res.result[produit_id] != undefined && res.result[produit_id][elem_id] != undefined) {
                var sizes_tab = res.result[produit_id][elem_id];
                var size_box, size_label, size_stock, is_disabled;
                var has_stock = res.result[produit_id]['stock_quantite'] > 0;

                for (size_id in sizes_tab) {
                    if (sizes_tab.hasOwnProperty(size_id)) {
                        size_box = $('.product_info_wrapper [name="itm_size"]').filter('[value="' + size_id + '"]');
                        size_label = $('.product_info_wrapper #label_' + size_id);
                        size_stock = parseInt(sizes_tab[size_id], 10) || 0;
                        is_disabled = (size_stock <= 0);

                        if (!is_disabled) {
                            size_box.removeClass('disabled');
                            size_label.removeClass('disabled');
                        } else {
                            size_box.addClass('disabled');
                            size_label.addClass('disabled');
                        }

                        // SW-22321 : "Dernieres pieces" suit le meme stock temps reel que l'alerte de restock,
                        // sinon les deux messages peuvent s'afficher en meme temps sur une taille epuisee
                        size_label.toggleClass('last_stock', !is_disabled && size_stock < 5);
                    }
                }

                if (has_stock) {
                    $("#bloc_add_basket").show();
                    $("#bloc_add_alert").hide();
                } else {
                    $("#bloc_add_basket").hide();
                    $("#bloc_add_alert").show();
                }
            }
        }
    });
}

/**
 * @description Recovers stock sizes by color and their stock
 *
 * @since 2022-11-04
 */
function setAvailableSizesCabas(arrayIdCabas) {
    let produit_id = arrayIdCabas;
    let data = {produit_id: produit_id};

    if (isGlobalEActive) {
        data.warehouse_only = 1;
    }

    $.ajax({
        url: path_relative_root + 'ajax_get_colisages_states_by_color_size.php',
        type: 'post',
        data: data,
        success: function (res) {
            try {
                res = $.parseJSON(res);
            } catch (e) {
                console.error("parseJSON");
                return;
            }

            if (res.success && res.result) {
                arrayIdCabas.forEach((produit_id) => {

                    // Ensure produit_id exists in the result
                    if (!res.result[produit_id]) {
                        console.warn("Produit ID not found:", produit_id);
                        return;
                    }

                    // Get stock quantity
                    var stock = res.result[produit_id]['stock_quantite'];

                    // Get the keys of the nested object
                    var nestedKeys = Object.keys(res.result[produit_id]);

                    // Find the key we want (skip non-object keys like 'stock_quantite')
                    var dynamicKey = nestedKeys.find(key => key !== 'stock_quantite' && key !== 'enableAlertStock');

                    if (!dynamicKey || !res.result[produit_id][dynamicKey]) {
                        return;
                    }

                    // Get the size_id from the dynamic key's object
                    var size_id = Object.keys(res.result[produit_id][dynamicKey])[0];

                    // Apply classes based on stock quantity
                    if (stock > 0 && stock <= 5) {
                        $("#label_" + size_id).addClass("last_stock");

                        var sizeText = $('.wrapper_select #size_' + size_id + ':checked + label .size_title').html() || '';

                        if (sizeText.includes(Translator.translate('porte_cabas'))) {
                            sizeText = 'L';
                        }

                        if (!sizeText.includes(Translator.translate('last_taunt'))) {
                            $("#prod_info_" + produit_id + " #js-sizeName").html(`${sizeText} - ${Translator.translate('last_taunt')}`);
                        }
                    } else if (stock === 0) {
                        if ($("#label_" + size_id).hasClass("last_stock")) {
                            $("#label_" + size_id).removeClass("last_stock");
                        }

                        $("#label_" + size_id).addClass("no_stock");
                    } else {
                        $("#label_" + size_id).removeClass("last_stock no_stock");
                    }
                });
            }
        }
    });
}

function openMultiShad(id, skipShade = true) {
    $("#" + id).addClass("actif");

    if (!skipShade) {
        $("#shad").addClass('no-skip-shade');
    }

    // Show modbox and make sure closing routine won't fire more than once
    $("#" + id).fadeIn(200, function () {

        $("#" + id).slideDown(600);
    });

    if (id !== 'zoomBox') {
        $("#shad").addClass('actif').on("click", function () {
            closeMultiShad(id);
        });
    }

    if (id === 'popup_numero_retour') {
        $('body').addClass('noScroll');
        setTimeout(function (){
            $('.wrapper_num_retour').overlayScrollbars({});
        }, 250);
    }

    if (id === 'selection-offer') {
        setTimeout(function (){
            $('#selection-offer-content').overlayScrollbars({});
        }, 250);

        // SW-13166 Trigger click when there is only one product to select
        if($('.js-form-selection-offer').length == 1) {
            $('.js-form-selection-offer').trigger('click');
        }
    }

    if(id === "zoomBox") {
        $('body').css('position','fixed');
        $('#zoom_box_wrapper .swiper-slide').on('click', function () {
            closeMultiShad('zoomBox');
        });
    }

    if (id === "delivery_home_choice") {
        $('body').css('position','fixed');
    }

    if ($("#buyNowSwiper").length > 0) {

        window.setTimeout(function () {

            buyNowSwiper = new Swiper("#buyNowSwiper", {

                width: 260,
                height: 390,
                sliderPerView: 1,
                navigation: {
                    nextEl: '.modboxNext',
                    prevEl: '.modboxPrev',
                },
                on: swiperLazyEvents
            });
        }, 50);
    }

    if(id == "selection-offer") {

        setTimeout(function () {

            $("#selection-offer-content").lionbars();
            var color_list = new Swiper('.color_list', {

                spaceBetween: 15,
                slidesPerView: 4,
                navigation: {
                    nextEl: '.nextColour',
                    prevEl: '.prevColour',
                },
                on: swiperLazyEvents
            });

            var size_list = new Swiper('.size_list', {

                spaceBetween: 15,
                slidesPerView: 4,
                navigation: {
                    nextEl: '.nextSize',
                    prevEl: '.prevSize',
                },
                on: swiperLazyEvents
            });
        }, 500);
    }

    if (id == 'popup_cofidis3cb') {
        // COFIDIS FP
        if ($('#popup_cofidis3cb .popup_container').length) {
            $('#popup_cofidis3cb .popup_container').overlayScrollbars({});
        }
    }

    if ((id === 'delivery_home_choice') ||
        (id === 'lightboxCustomerAddress') ||
        id.startsWith('relay_choice_')) {

        setTimeout(function () {
            $('.sidebar-right').overlayScrollbars({});
        }, 500);
    }

    if ((id === 'product_assoc_lightbox') ||
        (id === 'show_all_colors_lightbox')){
        $('body').addClass('noScroll');
    }

    if (id == 'traceForGoodLightbox') {
        if ($('#traceForGoodLightbox').hasClass('closing')) {
            $('#traceForGoodLightbox').removeClass('closing');
        }
    }
}

// Appelé après la fermeture du filtre précédent : position calculée sur le layout final
function scrollFilterIntoView($filter) {
    var $scroller = $("#rayon_sticky_block #filter_sticky");
    if (!$scroller.length || !$filter.length || !$scroller.has($filter).length) return;

    var gap = 20;
    var top = $filter.offset().top - $scroller.offset().top + $scroller.scrollTop() - gap;

    $scroller.stop(true).animate({ scrollTop: Math.max(0, top) }, 250);
}

function initSelectedFilterTags() {
    var $container = $("#rayon_sticky_block .choices_container");
    if (!$container.length) return;

    $container.empty();
    $("#filter_sticky input[type='checkbox'][data-name]:checked").each(function () {
        updateSelectedFilterTag(this);
    });
}

function initSelectedTriTag() {
    var $container = $("#rayon_sticky_block .choices_container");
    if (!$container.length) return;

    var $active = $("a.tri_price.actif").first();
    if ($active.length) {
        updateSelectedTriTag($active);
    }
}

function updateSelectedTriTag($link) {
    var $container = $("#rayon_sticky_block .choices_container");
    if (!$container.length) return;

    $container.find('.choice_tag[data-target="tri_price"]').remove();

    if ($link && $link.hasClass("actif")) {
        var name = $link.find("span").text() || $link.text();
        $container.append(buildFilterChip("tri_price", name));
    }

    updateApplyCounter();
}

function updateSelectedFilterTag(input) {
    var $container = $("#rayon_sticky_block .choices_container");
    if (!$container.length) return;

    var id = input.id;
    if (!id) return;

    var $existing = $container.find('.choice_tag[data-target="' + id + '"]');

    if (input.checked) {
        if ($existing.length) return;
        $container.append(buildFilterChip(id, getFilterChipLabel(input)));
    } else {
        $existing.remove();
    }

    updateApplyCounter();
}

// Sans "total", le dernier compteur connu est conservé (pas de clignotement pendant le comptage)
var pendingFiltersCount = null;

function updateApplyCounter(total) {
    var $counter = $("#rayon_sticky_block .block-btn-filter .dispo_number");
    if (!$counter.length) return;

    var hasSelection = $("#rayon_sticky_block .choices_container .choice_tag").length > 0;

    if (!hasSelection) {
        $counter.text("").hide();
        return;
    }

    if (typeof total === "number") {
        pendingFiltersCount = total;
    } else if (pendingFiltersCount !== null) {
        total = pendingFiltersCount;
    } else {
        total = parseInt($("#totalElems").val(), 10);
        if (isNaN(total)) {
            total = parseInt($("#nombre_articles").text(), 10) || 0;
        }
    }
    $counter.text("(" + total + ")").show();
}

function resetFiltersSelection() {
    var $container = $("#rayon_sticky_block .choices_container");
    if (!$container.length) return;

    $("#choice_tri").val(0);
    $("a.tri_price").removeClass("actif");
    $container.empty();
    pendingFiltersCount = null;
    updateApplyCounter();
}

function closeMultiShad(id) {
    if ($('#shad').hasClass('no-skip-shade')) {
        return;
    }

    $('#shad').off('click');
    $('#' + id).removeClass('actif');

    // Hide modbox and shade and destroy shade's click event
    $('#' + id).fadeOut("slow").queue(function () {

        if (id === "zoomBox" || id === "delivery_home_choice") {
            $('body').css('position','');
        }

        if($('#shad').is(":visible") && ($('body').hasClass('category') || $('body').hasClass('homepage') || $('body').hasClass('search_page_on')) && id === 'sizeguideBox'){

            $('#shad').css('display', 'block');

        } else if ($('#shad').is(":visible") && (id === 'country_switcher_lightbox')) {
            $('#shad').fadeOut(0).css('display', 'none').removeClass('actif');

        } else if ($('#shad').is(":visible")) {
            $('#shad').css('display', 'none').removeClass('actif');
        }

        if ($('#shad_abox').is(":visible")) {
            $('#shad_abox').fadeTo("slow", 0, function () {

                $('#shad_abox').css('display', 'none');
            });
        }

        $(this).dequeue();
    });

    if ($('#traceForGoodLightbox').hasClass('actif')) {
        $('#traceForGoodLightbox').removeClass('actif').addClass('closing');
    }

    // Removes actif class from shad without waiting for fadeOut to finish (fadeout not applicable to these lightboxes)
    if ((id.includes('confirmDeleteProductBasket_') && $('#shad').hasClass('actif')) ||
        (id === 'product_assoc_lightbox') ||
        (id === 'lightboxCustomerAddress') ||
        (id === 'show_all_colors_lightbox')) {
        $('#shad').removeClass('actif');
    }

    $('body').removeClass('noScroll');
}

function openColorsBox(id) {
    $("#" + id).addClass("actif");

    if ((id === 'product_assoc_lightbox') || (id === 'show_all_colors_lightbox')) {
        $('body').addClass('noScroll');
    }
}

/*
Page Mon compte Informations
Ajout texte champs obligatoires - Form login
*/
function infosObligatoires() {
    var loginFrm = $('.wrapper_content_mes_infos form[name="login"]');
    var lastFrmLn = loginFrm.find('.w-form-line').last();
    var text = '<p class="infos-obligatoires">' + Translator.translate('infos_obligatoires') + '</p>';

    if(lastFrmLn.length) {
        lastFrmLn.before(text);
    }
}

// Translation text function
(function() {
    'use strict';

    function parseArgs(args) {
        var obj = {},
            inc = 0,
            len = args.length;
        for (inc; inc < len; inc += 1) {
            obj['arg' + inc] = args[inc];
        }
        return obj;
    }

    function translate() {
        var o_data = parseArgs(arguments),
            s_resp = arguments[0];
        $.ajax({
            url: path_relative_root + 'ajax_sprintf.php',
            type: 'get',
            data: o_data,
            async: false,
            success: function(res) { s_resp = res }
        });
        return s_resp;
    }
    window.translate = translate;
}());

/* pour les tableaux du guide des tailles */
function fadeTaille(id, nbelem) {
    $("#content_quide_" + id).css('display, none');

    for (var i = 1; i <= nbelem; i++) {
        if (id != i && $("#content_quide_" + i).css('display') == 'block') {
            $("#content_quide_" + i).hide();
            $("#intitule_quide_" + i).removeClass('actif');
        }
    }

    if ($("#content_quide_" + id).css('display') != 'block') {
        $("#content_quide_" + id).fadeIn(600);
        $("#content_quide_" + id).addClass('actif');
        $("#intitule_quide_" + id).addClass('actif');
        $("#content_quide_" + id).css('display', 'block');
    } else {
        $("#content_quide_" + id).hide();
        $("#content_quide_" + id).removeClass('actif');
        $("#intitule_quide_" + id).removeClass('actif');
    }
}

/*# FIX SIDE NAV #*/
function updateCurrentNav() {
    var scrollAmount = $(document).scrollTop();
    var windowHeight = $(window).innerHeight();

    $(".productVisu").each(function() {
        var sectionBlocId = $(this).attr("id");
        var sectionBlocHeight = $("#" + sectionBlocId).innerHeight();
        var sectionBlocPosTop = $("#" + sectionBlocId).offset().top;

        if (
            sectionBlocPosTop - scrollAmount < windowHeight / 2 &&
            sectionBlocPosTop > scrollAmount - sectionBlocHeight / 2
        ) {
            $("." + sectionBlocId).addClass("actif");
            $("#" + sectionBlocId).addClass("actif");
        } else {
            $("." + sectionBlocId).removeClass("actif");
            $("#" + sectionBlocId).removeClass("actif");
        }
    });
}

if ($('.satellite_store_details .wrapper_store .images').length === 0) {
    $('.satellite_store_details ._wrapper_main').css({'justify-content' : 'flex-start','max-width': '840px'});
};

function close_popup(elem) {
    var $modbox = $("#" + elem);
    var $shad = $("#shad");
    $shad.attr("onclick", "");
    $shad.animate({opacity: 0}, 350, function() {
        $shad.css({display: "none", opacity: ""}).data("opened_lb", 0);
    });
    $modbox.css({display: "none"});
}

function openSizeSelection() {
    if($('#size_select_cta').length) {
        $('html, body').animate({
            scrollTop: $('#size_select_cta').offset().top - 200
        }, 300);
    }
    $('.size_selection_wrapper').addClass('open');
}

if (window.matchMedia('(min-width: 1024px)').matches) {
    var e = document.getElementsByClassName("phone");
    for (i = 0; i < e.length; i++)
        e[i].setAttribute("x-ms-format-detection", "none");
}

function scrollToDonationBox() {
    if ($('.cart.fr .main_wrapper #container_other_information').length ) {
        $(".donation_savoir_plus").on('click tap touch', function () {
            // Calculate the scroll position to center the container
            var screenHeight = $(window).height();
            var containerHeight = $("#container_other_information").height();
            var scrollTo = (containerHeight - screenHeight) / 2;

            // Scroll to the calculated position with smooth animation
            $('html, body').animate({
                scrollTop: $("#container_other_information").offset().top + scrollTo
            }, 1000);
        });
    }
}

$(".homepage .home-module-cta a").each(function(){
    if (!$(this).text().trim().length) {
        $(this).css('border', 'transparent').hide();
    } else {
        $(this).css('opacity', '1');
    }
});

$(".homepage .home-module-cta").each(function(){

    if (!$(this).text().trim().length) {
        $(this).find('.tiret_cta').css('background', 'transparent').hide();
    } else {
        $(this).find('.tiret_cta').css('opacity', '1');
    }
});

if ($('.home-module.tg-module').length) {

    var journalModuleSwiper = new Swiper( ".tg-module .main-swiper", {
        slidesPerView: 4,
        loop: false,
        spaceBetween: 12,
        navigation: {
            nextEl: ".tg-module-next",
            prevEl: ".tg-module-prev",
        },
        on: swiperLazyEvents
    } );
}

/* Page cart */
$("body.cart.step_1 #cart_total .bill_line.shipping_information").insertAfter("body.cart.step_1 #cart_total .bill_line.total");

/* page livraison */
$("body.cart.step_2 .order_recap .bill_line.shipping_information").insertAfter("body.cart.step_2 .order_recap .order_total.subtotal");

// Fade in filter when page is ready
// /!\To test if global-e is activated we need to wait after all elements are loaded
$(window).on('load', function () {
    if ($('.block_filters').length) {
        if ($('.block_filters').hasClass('faded')) {
            $('.block_filters').removeClass('faded');
        }
    }
    var filterSizes = $('#block_filters #filter_sizes');
    if (isGlobalEActive) {
        $('body').addClass('isOperatedByGlobalE');
        filterSizes.remove();
    } else {
        $('body').removeClass('isOperatedByGlobalE');
        filterSizes.show();
    }
});

/**
 * Function to manage the "Read more" button on the department page
 */
let scrollText = function () {
    let elementSeoText = $('.textSeo_bloc_description');
    if (elementSeoText.hasClass('see_more')) {
        elementSeoText.removeClass('see_more').addClass('see_less');
    } else {
        elementSeoText.removeClass('see_less').addClass('see_more');
    }
}

// Toggle voir plus / voir moins for #push_rayon .txt_bandeau
$(document).on('click', '#push_rayon .seeMore', function () {
    var $wrapper = $(this).closest('.txtWrapper');
    $wrapper.addClass('expanded');
    $(this).hide();
    $wrapper.find('.seeLess').show();
});

$(document).on('click', '#push_rayon .seeLess', function () {
    var $wrapper = $(this).closest('.txtWrapper');
    $wrapper.removeClass('expanded');
    $(this).hide();
    $wrapper.find('.seeMore').show();
});

//prefooter block collapse class based css animated
$('.block_links_prefooter .collapse').on("click", function () {
    var prefooter = $('.block_links_prefooter .collapse');

    if (prefooter.hasClass('hidden')){
        prefooter.removeClass('hidden');
    } else {
        prefooter.addClass('hidden');
    }
});

/**
 * Switch main product image with the selected thumbnail
 *
 * @param {String} imgSrc
 *
 * @returns {void}
 */

function switchMainVisu(imgSrc) {
    const mainImg = $('#jqzoom .main-picture').first();
    const choicesContainer = $('.choices_list.color_list');

    // If main image or container does not exist, stop here
    if (!mainImg.length || !choicesContainer.length) return;

    // Initialize behavior only once
    if (!choicesContainer.data('switch-init')) {
        choicesContainer.data('switch-init', true);

        // Helper: show the image of the currently checked color
        function showCheckedColorImage() {
            // Find the checked radio input inside color items
            const checkedInput = choicesContainer
                .find('.form_itm.check.color input[type="radio"]:checked')
                .first();

            if (checkedInput.length) {
                // Get image URL from data-pic attribute
                const pic = checkedInput.data('pic');

                if (pic) {
                    mainImg.attr('src', pic);
                }
            }
        }

        // On first initialization, ensure main image matches the checked color
        showCheckedColorImage();

        // When the mouse leaves the whole color choices container,
        // reset the main image back to the checked color's image
        choicesContainer.on('mouseleave', function () {
            showCheckedColorImage();
        });

        // If the user changes the color by clicking,
        // update the main image to the newly selected color
        choicesContainer.on('change', '.form_itm.check.color input[type="radio"]', function () {
            const pic = $(this).data('pic');
            if (pic) {
                mainImg.attr('src', pic);
            }
        });
    }

    // On hover, if an image source is provided, show that image
    if (imgSrc) {
        // Replace 'medium' with 'large' to get the high-res version
        mainImg.attr('src', imgSrc.replace('medium', 'large'));
    }
}

function loadSlideImages(slide) {
    if (!slide) return;
    slide.querySelectorAll('img[data-src]').forEach(function(img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.setAttribute('is-loaded', '');
    });

    slide.querySelectorAll('source').forEach((source) => {
        const ds = source.getAttribute('data-srcset');
        if (!ds) return;
        source.setAttribute('srcset', ds);
        source.removeAttribute('data-srcset');
        source.setAttribute('is-loaded', '');
    });
}

/**
 * Loads data-src → src on .item-product-picture in the current real
 * slides. Skips loop-clone slides; uses realIndex to stay loop-safe.
 *
 * Both image.php ('slider' => true) and tp_image.php (attributes: ['is-slider' => true])
 * stash the real url in "data-twic-src-slider" for non-active slides so TwicPics never
 * sees it ahead of time; this swaps it back to "data-twic-src" on activation.
 *
 * @param {HTMLElement} gallery - The .item-visuals element
 * @param {Swiper} swiper
 */
function hydrateActiveSlide(gallery, swiper) {
    const realSlides = Array.from(
        gallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
    );
    if (!realSlides.length) return;

    const count = realSlides.length;
    const current = swiper.realIndex % count;

    [current].forEach((i) => {
        const slide = realSlides[i];
        if (!slide) return;

        slide.querySelectorAll('.item-product-picture, .item-product-picture-rollover').forEach((img) => {
            // TwicPics only picks up "data-twic-src" on elements inserted into the DOM,
            // it ignores attributes added to an already-existing node, so the placeholder
            // image is replaced with a clone carrying the real attribute instead of mutating it in place.
            const twicSrc = img.getAttribute('data-twic-src-slider');
            if (twicSrc) {
                const loadedImg = img.cloneNode(true);
                loadedImg.setAttribute('data-twic-src', twicSrc);
                loadedImg.removeAttribute('data-twic-src-slider');
                loadedImg.removeAttribute('is-slider');
                img.replaceWith(loadedImg);
                return;
            }

            const ds = img.getAttribute('data-src');
            if (!ds) return;
            img.setAttribute('src', ds);
            img.removeAttribute('data-src');
            img.setAttribute('is-loaded', '');

            const srcset = img.getAttribute('data-srcset');
            if (!srcset) return;
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-srcset');
        });

        slide.querySelectorAll('source').forEach((source) => {
            const ds = source.getAttribute('data-srcset');
            if (!ds) return;
            source.setAttribute('srcset', ds);
            source.removeAttribute('data-srcset');
            source.setAttribute('is-loaded', '');
        });
    });
}

/**
 * Initializes the Swiper on a single .item-visuals gallery.
 * Nav elements are resolved within the gallery to prevent cross-contamination
 * when multiple swipers share the same button class names.
 *
 * @param {HTMLElement} gallery - The .item-visuals element
 */
function initRayonItemSlider(gallery) {
    if (gallery.classList.contains('swiper-initialized')) return;

    const itemSlider = new Swiper(gallery, {
        loop: true,
        roundLengths: true,
        navigation: {
            nextEl: gallery.querySelector('.item-swiper-button.next'),
            prevEl: gallery.querySelector('.item-swiper-button.prev'),
        },
    });

    hydrateActiveSlide(gallery, itemSlider);
    itemSlider.on('slideChange', () => hydrateActiveSlide(gallery, itemSlider));
}

/**
 * Registers all .item-visuals galleries with an IntersectionObserver so each
 * Swiper is only initialized when the tile enters the viewport.
 */
function initializeItemSliders() {
    const galleries = document.querySelectorAll('.item-visuals');
    if (!galleries.length) return;

    const io = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                if (entry.target.classList.contains('no-slider')) {
                    // no Swiper instance here, so lock the nav buttons manually
                    entry.target.querySelectorAll('.item-swiper-button').forEach((btn) => {
                        btn.classList.add('swiper-button-lock');
                    });
                    // no Swiper: hydrate data-src directly so rollover image loads
                    entry.target.querySelectorAll('img[data-src]').forEach((img) => {
                        img.setAttribute('src', img.getAttribute('data-src'));
                        img.removeAttribute('data-src');
                        img.setAttribute('is-loaded', '');
                    });
                    entry.target.querySelectorAll('source[data-srcset]').forEach((source) => {
                        source.setAttribute('srcset', source.getAttribute('data-srcset'));
                        source.removeAttribute('data-srcset');
                        source.setAttribute('is-loaded', '');
                    });
                } else {
                    initRayonItemSlider(entry.target);
                }
                observer.unobserve(entry.target);
            });
        },
        { root: null, threshold: 0, rootMargin: '100px 0px' }
    );

    galleries.forEach((g) => io.observe(g));
}

const swiperLazyEvents = {
    slideChange() {
        loadSlideImages(this.slides[this.activeIndex]);
    }
};